import { Helmet } from "react-helmet-async"
import { ChurnRiskReport } from "../../../../Admin/TenantReports"

export default function ChurnRiskReportPage() {
	return (
		<>
			<Helmet>
				<title>Churn Risk</title>
			</Helmet>
			<ChurnRiskReport />
		</>
	)
}
